import type { NodeKind } from '@netdeck/contracts';

/**
 * Типы узлов, у которых дополнительные адреса (ADR 035) не показываются.
 *
 * Диапазон адресов заводят там, где за одним значком на схеме стоит много
 * машин: подсеть рабочих мест, пул серверов, стойка. У камеры, регистратора,
 * принтера и ИБП такого не бывает — это одно устройство с одним адресом,
 * и раздел на всю панель, полоса точек на карточке и пометка «+N» в списке
 * занимали бы место под то, чего у этих типов не случается.
 *
 * Скрывается только показ: сами адреса и их мониторы платформа продолжает
 * хранить и проверять. Удалять их вместе с типом значило бы терять историю
 * проверок при опечатке в поле «тип узла».
 */
const KINDS_WITHOUT_EXTRA_ADDRESSES: ReadonlySet<NodeKind> = new Set<NodeKind>([
  'camera',
  'nvr',
  'printer',
  'ups',
]);

/** Показывать ли дополнительные адреса у узла этого типа. */
export function showsExtraAddresses(kind: NodeKind): boolean {
  return !KINDS_WITHOUT_EXTRA_ADDRESSES.has(kind);
}
